var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"non-text-transformation link",attrs:{"tile":"","large":"","color":"primary","disabled":_vm.disabled},on:{"click":_vm.handleClick}},[_vm._v(" "+_vm._s(_vm.$t('STEPPER_BUTTON_MANUAL_SIGN'))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }